import React from 'react';
import FormElement from "Components/Core/Form/FormElement";

// Hoehe der Chat-Composer-Leiste bei einzeiligem Feld (entspricht dem frueheren
// festen Wert in Postings.css) und Obergrenze fuer das mitwachsende Eingabefeld.
const COMPOSER_BASE_HEIGHT = 56;
const COMPOSER_MAX_HEIGHT = 100;

export default function PostingElement(props) {

    const x = props.x;

	const [newThread, setNewThread] = React.useState([""]);
	const classes = (typeof props.classes === 'undefined') ? null : props.classes;
	const children = (typeof props.children === 'undefined') ? null : props.children;

	// Im Chat-Modus ist pro offenem Forum ein eigener Composer gleichzeitig
	// gemountet (auch wenn nur einer sichtbar ist) - eine einzelne globale
	// Referenz (x.was.setNewThreadShort = setNewThread) wurde dabei von jeder
	// Instanz ueberschrieben, sodass am Ende nur noch die zuletzt gerenderte
	// tatsaechlich reagierte. Jetzt je wafId gesondert registriert.
	x.was.setNewThreadShortByWafId = x.was.setNewThreadShortByWafId || {};
	x.was.setNewThreadShortByWafId[props.wafId] = setNewThread;

	const lastTypingSent = React.useRef(0);
	const singleLineHeight = React.useRef(null);

	function emitTyping() {
		const now = Date.now();
		if (now - lastTypingSent.current > 2000) {
			lastTypingSent.current = now;
			x.was.send('typing', { "memberid": x.was.memberId, "forumId": x.wam.getForumId() });
		}
	}

	function checkPaste(event) {
		let text = event.clipboardData.getData('text');
		const forumId = x.wam.getForumId();
		if (x.wau.checkPaste(text, true, openNewThread)) {
			event.preventDefault();
		}
		else if (text.split('\n').length > 1) {
			x.waf.set(forumId + '-new-thread', 'posting', text);
			x.wam.openNewThread()
			event.preventDefault();
		}
	}

	function openNewThread() {
		// let currentTitle = newThread;
		const forumId = x.wam.getForumId();
		x.wam[forumId].showDialogNewThread();
		// Tabs-Komponente (tabs.js) wird aktuell nirgends mehr eingebunden, daher existiert
		// setTab() nicht mehr - Aufruf absichern statt den kompletten Ablauf abstuerzen zu lassen.
		if (typeof x.wam[forumId].setTab === 'function') x.wam[forumId].setTab('postings');
		x.wam.activate(forumId);
	}

	function newThreadChanged(value) {
		setNewThread(value);
		emitTyping();
		if (typeof props.onChange !== 'undefined') props.onChange(value);
	}

	// Enter sendet, Shift+Enter erzeugt einen Zeilenumbruch (analog Rocket.Chat).
	// Ohne diesen Handler wuerde das <textarea> bei Enter nur umbrechen, statt
	// abzuschicken - ein <input> haette das Formular von sich aus abgeschickt.
	function checkKeyDown(event) {
		if (event.key === 'Enter' && !event.shiftKey) {
			event.preventDefault();
			if (typeof props.onEnter === 'function') props.onEnter(event);
			return;
		}
		if (typeof props.onKeyDown === 'function') props.onKeyDown(event);
	}

	// Mehrzeilige Eingaben sichtbar machen, statt sie im einzeiligen Feld
	// verschwinden zu lassen. Die Obergrenze verhindert, dass der Composer bei
	// langen Texten das halbe Forum verdeckt. In der Top-Navigations-Variante
	// bleibt die Hoehe fix, dort setzt das CSS "height:auto !important"
	// (NewPosting.css) - das gewinnt bewusst gegen diesen Inline-Stil.
	//
	// Im Chat-Modus muss zusaetzlich die Composer-Leiste selbst mitwachsen: sie
	// ist absolut positioniert und war fest auf 56px gesetzt, ebenso der untere
	// Abstand der Beitragsliste darueber (Postings.css). Ein hoeheres Feld lief
	// sonst sichtbar aus der Leiste heraus. Beide lesen die Hoehe jetzt aus
	// --composer-height, gesetzt auf dem gemeinsamen Eltern-Element
	// (.forum-postings-column) - eine CSS-Variable vererbt sich nur nach unten,
	// die Leiste allein wuerde ihre Geschwister-Liste nicht erreichen.
	React.useEffect(() => {
		const element = x.waf[props.wafId]?.elements?.[props.id]?.reference?.current;
		if (!element || element.tagName !== 'TEXTAREA') return;
		element.style.height = 'auto';
		const height = Math.min(element.scrollHeight, COMPOSER_MAX_HEIGHT);
		element.style.height = height + 'px';

		// Hoehe des einzeiligen Feldes einmalig merken (der Composer startet leer)
		// und die Leiste nur um das wachsen lassen, was tatsaechlich an Zeilen
		// dazukommt - so bleibt sie bei einer Zeile exakt bei ihrer bisherigen
		// Hoehe, statt sich aus einer fest gerechneten Formel zu ergeben.
		if (singleLineHeight.current === null) singleLineHeight.current = height;

		const bar = element.closest('.chat-mode-composer');
		if (!bar || !bar.parentElement) return;
		const extra = Math.max(0, height - singleLineHeight.current);
		bar.parentElement.style.setProperty('--composer-height', (COMPOSER_BASE_HEIGHT + extra) + 'px');
	}, [newThread, x.waf, props.wafId, props.id]);

	return (
		<FormElement
			type="text"
			multiline={true}
			id={props.id}
			wafId={props.wafId}
			x={x}
			value={newThread}
			classes={classes}
			maxLength="500"
			placeholder="Neuer Beitrag"
			onPaste={checkPaste}
			onKeyDown={checkKeyDown}
			onChange={event => newThreadChanged(event.target.value)}
			onFocus={props.onFocus}
			onBlur={props.onBlur}
			children={children}
			style={{ border: 'none' }}
			autoComplete={(typeof props.autoComplete === 'undefined') ? 'on' : props.autoComplete}
			spellCheck={false}
			disabled={props.disabled}
		/>
	);

}
